import { useRef } from "react";
import { sizes, headerAmount, headerSizes } from "../../constants/sizes";
import { pixels } from "../../constants/pixels";
import { windowHeaderSum, doorHeaderSum } from "./functions";
import { ReactComponent as HomeIcon } from "../../svgs/home.svg";
import styled from "styled-components";

import { useReactToPrint } from "react-to-print";

const GeneralNotes = styled.div`
  border: 1px solid lightgrey;
  border-radius: 3px;
  padding: 10px;
  font-weight: bold;
`;

const Main = ({ project, handleEditProject }) => {
  const {
    bottomPlate,
    eaves,
    h,
    kitName,
    nailingPattern,
    size,
    stud,
    walls,
    location,
    foundation,
    siding,
    ceiling,
    additionWindows,
    productionDate,
    generalNotes,
  } = project;

  const nailingPatternParse = (e) => {
    if (e) {
      const arr = e.split(/[^A-Za-z0-9]/);
      return `${arr[0]}" / ${arr[1]}"`;
    }
    return null;
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="sheet-comp-container">
      <div className="sheet-input">
        <div id="sheet-print-button" onClick={handlePrint}>
          print
        </div>
        <div className="sheet-input-item">
          <label>Production Date</label>
          <input
            className="form-control"
            name="productionDate"
            type="date"
            onChange={(e) => handleEditProject(e)}
            defaultValue={productionDate}
          />
        </div>
        <div className="sheet-input-item">
          <label>Location</label>
          <input
            className="form-control"
            name="location"
            onChange={(e) => handleEditProject(e)}
            defaultValue={location}
          />
        </div>
        <div className="sheet-input-item">
          <label>Foundation</label>
          <input
            className="form-control"
            name="foundation"
            onChange={(e) => handleEditProject(e)}
            defaultValue={foundation}
          />
        </div>
        <div className="sheet-input-item">
          <label>Cedar Siding</label>
          <input
            className="form-control"
            name="siding"
            onChange={(e) => handleEditProject(e)}
            defaultValue={siding}
          />
        </div>
        <div className="sheet-input-item">
          <label>Eaves</label>
          <select
            className="form-control"
            name="eaves"
            onChange={(e) => handleEditProject(e)}
            defaultValue={eaves}
          >
            <option value="16">16"</option>
            <option value="24">24"</option>
          </select>
        </div>
        <div className="sheet-input-item">
          <label>Ceiling</label>
          <input
            className="form-control"
            name="ceiling"
            onChange={(e) => handleEditProject(e)}
            defaultValue={ceiling}
          />
        </div>
        <div className="sheet-input-item">
          <label>Addition Windows</label>
          <input
            className="form-control"
            name="additionWindows"
            onChange={(e) => handleEditProject(e)}
            defaultValue={additionWindows}
          />
        </div>
        <div className="sheet-input-item">
          <label>General Notes</label>
          <textarea
            className="form-control"
            name="generalNotes"
            onChange={(e) => handleEditProject(e)}
            defaultValue={generalNotes}
          />
        </div>
      </div>
      <div className="sheet-output" ref={componentRef}>
        <div className="sheet-title">
          <div className="sheet-icon-title">
            <HomeIcon />

            <div>General Overview</div>
          </div>
          <div>
            {kitName} - {sizes[size]}
          </div>
        </div>
        <div className="sheet-body">
          <div className="sheet-column">
            <div className="sheet-item">
              <div>Size</div>
              <div>{sizes[size]} ft</div>
            </div>
            <div className="sheet-item">
              <div>Height</div>
              <div>{h / pixels / 12} ft</div>
            </div>
            <div className="sheet-section"></div>
            <div className="sheet-item">
              <div>Stud Spacing</div>
              <div>{stud / pixels}"</div>
            </div>
            <div className="sheet-item">
              <div>Nailing Pattern</div>
              <div>{nailingPatternParse(nailingPattern)}</div>
            </div>
            <div className="sheet-item">
              <div>Bottom Plates</div>
              <div>{bottomPlate}</div>
            </div>
            <div className="sheet-item">
              <div>Window Headers</div>
              <div>
                {
                  headerAmount[
                    windowHeaderSum(walls, "window1", "headerAmount")
                  ]
                }{" "}
                {headerSizes[windowHeaderSum(walls, "window1", "header")]}
              </div>
            </div>
            <div className="sheet-item">
              <div>Door Headers</div>
              <div>
                {headerAmount[doorHeaderSum(walls, "headerAmount")]}{" "}
                {headerSizes[doorHeaderSum(walls, "header")]}
              </div>
            </div>
          </div>

          <div className="sheet-column">
            <div className="sheet-item">
              <div>Location</div>
              <div>{location}</div>
            </div>

            <div className="sheet-item">
              <div>Cedar Siding</div>
              <div>{siding}</div>
            </div>

            <div className="sheet-section"></div>
            <div className="sheet-item">
              <div>Eaves</div>
              <div>{eaves}"</div>
            </div>
            <div className="sheet-item">
              <div>Ceiling</div>
              <div>{ceiling}</div>
            </div>
            <div className="sheet-item">
              <div>Ring Size</div>
              <div>{size < 32 ? 5 : 6} ft</div>
            </div>

            <div className="sheet-section"></div>
            {additionWindows ? (
              <div className="sheet-item">
                <div>Addition Windows</div>
                <div>{additionWindows}</div>
              </div>
            ) : null}
          </div>
        </div>
        <GeneralNotes>{generalNotes}</GeneralNotes>
      </div>
    </div>
  );
};

export default Main;
